module.exports = __webpack_public_path__ + "static/laptop_bj-0f47336df70596cfbc688f181c8e9882.png";